import { FC } from 'react';
import { getDateShortFormat } from '../../../../../utils/dates';
import { DefaultCell } from '@silverfort/sf-components';

interface Props {
    date: Date;
}

const DateCell: FC<Props> = ({ date }) => {
    return <DefaultCell text={getDateShortFormat(date)} />;
};

export default DateCell;
